import React from "react";
import { FaPlay } from "react-icons/fa";
import "./InfoSection.css"; // We'll create this for styling

const InfoSection = ({ 
  title, 
  subtitle, 
  description, 
  image, 
  videoLink, 
  reverse = false 
}) => {
  return (
    <section className={`container info-section ${reverse ? "reverse" : ""}`}>
      <div className="info-text">
        <h2>{title}</h2>
        {subtitle && <h2><b>{subtitle}</b></h2>}
        <p>{description}</p>
      </div>
      <div className="info-media">
        <div className="image-wrapper">
          <img src={image} alt={title} />
        </div>
      </div>
    </section>
  );
};

export default InfoSection;
